import { render, staticRenderFns } from "./WorkreportEdit.vue?vue&type=template&id=a68b0654&scoped=true"
import script from "./WorkreportEdit.vue?vue&type=script&lang=js"
export * from "./WorkreportEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkreportEdit.vue?vue&type=style&index=0&id=a68b0654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68b0654",
  null
  
)

export default component.exports